// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type=number]::-webkit-outer-spin-button, input[type=number]::-webkit-inner-spin-button {\n  -webkit-appearance: none !important;\n}\ninput[type=number] {\n  -moz-appearance: textfield;\n  /* firefox */\n}", ""]);
// Exports
module.exports = exports;
